import React, { useEffect } from "react";
import { Table } from "antd";
import { useWarehouseModel } from "../warehouseModel";
import { IMdWarehouseDetail } from "../warehouseService";
import { ColumnsType } from "antd/es/table";

const columns: ColumnsType<IMdWarehouseDetail> = [
    {
        align: "center",
        title: '版本',
        width: 80,
        dataIndex: 'branch',
    },
    {
        align: "center",
        title: '禁用',
        dataIndex: 'enable',
        render: v => v === 1 ? "否" : "是"
    },
    {
        align: "center",
        title: '编码',
        dataIndex: 'code',
    },
    {
        align: "center",
        title: '名称',
        dataIndex: 'name',
    },
    {
        align: "center",
        title: '组织机构编码',
        dataIndex: 'orgCode',
    },
    {
        align: "center",
        title: '组织机构名称',
        dataIndex: 'orgName',
    },
    {
        align: "center",
        title: '联系人',
        dataIndex: 'contact',
    },
    {
        align: "center",
        title: '联系电话',
        dataIndex: 'phone',
    },
    {
        align: "center",
        title: '联系地址',
        dataIndex: 'address',
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        width: 80,
        render: (v) => v === 0 ? "正常" : "异常"
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },

];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useWarehouseModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMdWarehouseDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
